import * as React from "react";
const SvgDisqualified = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 7L7 17M17 17L7 7", stroke: "#001033", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgDisqualified;
